import { TicketTextFormTranslations } from './ticket-text-form.model';

const _prefix = 'ticket-text-form_';

export const DEFAULT_TRANSLATION_KEYS: TicketTextFormTranslations = {
  placeholders: {
    ticketMessage: _prefix + 'placeholders_ticketMessage'
  }
};
